<style lang="less" scoped>
*{list-style-type: none;}
.center{width: 100%;display: flex;flex-direction: column;background: #fff;position: relative;}
.headnav{width: 1200px;margin: auto;
  .title{width: 314px;line-height: 50px;font-size: 16px;font-weight: 700;text-align: left;margin: 0;}
}
.detlist{width: 1200px;margin: auto;display: flex; justify-content:space-between}
.det_left{width: 830px;margin-bottom: 30px;}
.bot_center{margin: 0;padding: 0;display: flex;justify-content: space-between;margin-bottom:30px;flex-wrap: wrap;
  li{width: 255px;border-radius: 4px;background-color: #eeeeee;margin: 10px 0;
    img{width: 100%;height: 130px;}
    p{display: flex;flex-direction: column;margin: 0;text-align: left;padding: 5px 10px;font-size: 16px;line-height: 28px;color: #08032b;}
  }
}
.el-button{width: 100px;height: 36px;box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.16);border-radius: 4px;}
.delright{width: 340px;height: 254px;box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.4);border-radius: 4px; margin-top: 10px;}
.top_center{display: flex;justify-content:space-between;margin-top: -10px;}
.left{width: 90px;text-align: right;font-family: Microsoft YaHei;letter-spacing: 1px;font-weight: 600;}
.right{width: 220px;text-align: left;font-family: Microsoft YaHei;letter-spacing: 1px;
  p:nth-child(3){width:230px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  p:nth-child(5){width:230px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
}
</style>

<template>
  <div class="center">
    <div class="headnav">
      <p class="title">企业介绍 > 产品推介</p>
    </div>
    <div class="detlist">
      <div class="det_left">
        <ul class="bot_center">
          <li v-for="(each, index) in 12" :key="index">
            <img src="static/images/zlkindex/矿业资讯.png" alt="">
            <p>
              <span>产品名：越南锌灰</span>
              <span>单价：电议</span>
              <span>地区：电议</span>
            </p>
          </li>
        </ul>
        <el-button>加载更多</el-button>
      </div>
      <div class="delright">
        <el-card class="box-card">
          <div slot="header" style="font-weight: 600;">
            <span>联系方式</span>
          </div>
          <div class="top_center">
            <div class="left">
              <p>联系人：</p>
              <p>电话：</p>
              <p>邮箱：</p>
              <p>手机：</p>
            </div>
            <div class="right">
              <p>412169415@qq.com</p>
              <p>027-86860886</p>
              <p>412169415@qq.com</p>
              <p>13507199618</p>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data()
  {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {}
}
</script>





// WEBPACK FOOTER //
// src/plugins/app/project/QXdetails.vue